import { HOTELS } from '../data.js';
import { state, priceFor, slots, isFav } from '../state.js';
import { t, formatPriceParts, formatPrice, amenLabel } from '../i18n.js';
import { setFlaps } from './flap.js';

function $(id) {
  return document.getElementById(id);
}

export function openSheet(id) {
  $('scrim').classList.add('show');
  $(id).classList.add('show');
}

export function closeSheet() {
  $('scrim').classList.remove('show');
  $('sheet').classList.remove('show');
}

export function openCitySheet() {
  $('scrim').classList.add('show');
  $('citySheet').classList.add('show');
}

export function closeCitySheet() {
  $('scrim').classList.remove('show');
  $('citySheet').classList.remove('show');
}

export function openSetSheet() {
  $('scrim').classList.add('show');
  $('setSheet').classList.add('show');
}

export function closeSetSheet() {
  $('scrim').classList.remove('show');
  $('setSheet').classList.remove('show');
}

// ---------- detail sheet ----------

const heartSvg = (filled) =>
  `<svg viewBox="0 0 24 24" fill="${filled ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 21s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 5.5-7 10-7 10z" />
  </svg>`;

let onFavInDetail = () => {};
export function setDetailFavHandler(fn) {
  onFavInDetail = fn;
}

export function openDetails(i) {
  const h = HOTELS[i];
  const p = priceFor(h);
  const hot = h.left <= 2;
  const pics = h.pics || [];
  const amen = h.amen || ['Wi-Fi', 'A/C'];
  const desc = h.desc || '';
  const fav = isFav(i);
  const fp = formatPriceParts(p.now);
  const fpWas = p.was != null ? formatPriceParts(p.was) : null;
  const priceBlock =
    state.mode === 'night'
      ? `<div class="dnow">${fp.num} <span>${fp.unit}</span></div>
         <div class="dwas"><s>${fpWas.num} ${fpWas.unit}</s><span class="off">−${p.off}%</span> ${t('detail.tonight.tag')}</div>`
      : `<div class="dnow">${fp.num} <span>${fp.unit}</span></div>
         <div class="dwas">${t('card.dayblock', { n: state.hours })}</div>`;

  $('sheetView').innerHTML = `
    <div class="grab"></div>
    <div class="gallery" id="gallery">
      ${pics
        .map(
          (src, k) => `<div class="gslide">
            <img src="${src}" alt="${h.nm} photo ${k + 1}" loading="lazy" decoding="async" />
          </div>`,
        )
        .join('')}
      <button class="dxbtn" id="sheetX" aria-label="Close">×</button>
      <button class="dheart${fav ? ' on' : ''}" id="detailHeart" data-i="${i}" aria-label="${fav ? 'Remove from saved' : 'Save for later'}" aria-pressed="${fav}">
        ${heartSvg(fav)}
      </button>
      ${
        hot
          ? `<span class="dleft hot">${t('card.left', { n: h.left })}</span>`
          : `<span class="dleft">${t('detail.rooms.left', { n: h.left })}</span>`
      }
      <div class="gdots" id="gdots">
        ${pics.map((_, k) => `<i class="${k === 0 ? 'on' : ''}"></i>`).join('')}
      </div>
    </div>
    <div class="sheet-b">
      <div class="dhead">
        <div>
          <div class="t">${h.nm}</div>
          <div class="s">${h.area} · ${h.city} · ${'★'.repeat(h.st)}</div>
        </div>
      </div>
      <div class="amen-row">
        ${amen.map((a) => `<span class="amen">${amenLabel(a)}</span>`).join('')}
      </div>
      ${desc ? `<p class="ddesc">${desc}</p>` : ''}
      <div class="kv">
        <span class="k">${state.mode === 'night' ? t('detail.stay') : t('detail.window')}</span>
        <span class="v">${state.mode === 'night' ? t('detail.tonight') : h.win}</span>
      </div>
      <div class="kv">
        <span class="k">${t('detail.mode')}</span>
        <span class="v">${
          state.mode === 'night'
            ? t('detail.overnight')
            : t('detail.dayuse', { n: state.hours })
        }</span>
      </div>
      <div class="dprice-row">
        <div class="dprice">${priceBlock}</div>
        <button class="cta dcta" id="detailBook">
          ${state.mode === 'night' ? t('detail.book.night') : t('detail.book.day')}
        </button>
      </div>
      <div class="fine">${t('detail.fine')}</div>
    </div>`;

  // gallery dots tracker
  const gallery = $('gallery');
  const dots = $('gdots');
  if (gallery && dots) {
    gallery.addEventListener('scroll', () => {
      const idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
      dots
        .querySelectorAll('i')
        .forEach((d, k) => d.classList.toggle('on', k === idx));
    });
  }

  $('sheetX').onclick = closeSheet;
  $('detailBook').onclick = () => openBooking(i);
  $('detailHeart').onclick = (e) => {
    e.stopPropagation();
    onFavInDetail(i);
  };
  openSheet('sheet');
}

// ---------- booking sheet ----------

export function openBooking(i) {
  const h = HOTELS[i];
  const p = priceFor(h);
  const when =
    state.mode === 'day'
      ? t('book.when.day', { slot: slots(h)[0], n: state.hours })
      : t('detail.tonight');
  const fp = formatPriceParts(p.now);
  const fpWas = p.was != null ? formatPriceParts(p.was) : null;

  $('sheetView').innerHTML = `
    <div class="grab"></div>
    <div class="sheet-h">
      <div>
        <div class="t">${h.nm}</div>
        <div class="s">${h.area} · ${h.city} · ${'★'.repeat(h.st)}</div>
      </div>
      <button class="x" id="sheetX" aria-label="Close">×</button>
    </div>
    <div class="sheet-b">
      <div class="kv"><span class="k">${t('book.stay')}</span><span class="v">${
        state.mode === 'day' ? t('book.dayuse') : t('book.overnight')
      }</span></div>
      <div class="kv"><span class="k">${t('book.when')}</span><span class="v">${when}</span></div>
      <div class="kv"><span class="k">${t('book.guests')}</span><span class="v">${t('book.guests.value')}</span></div>
      ${
        p.off
          ? `<div class="kv"><span class="k">${t('book.saving')}</span><span class="v">−${p.off}% · ${fpWas.num} ${fpWas.unit}</span></div>`
          : ''
      }
      <div class="total">
        <span class="k">${t('book.youpay')}</span>
        <span style="display:flex;align-items:flex-end">
          <span class="flapline" id="totalFlap"></span>
          <span class="cur" id="totalCur">${fp.unit}</span>
        </span>
      </div>
      <button class="cta" id="confirm">${t('book.confirm')}</button>
      <div class="fine">${t('book.fine')}</div>
    </div>`;

  setFlaps($('totalFlap'), fp.num, false);
  $('sheetX').onclick = closeSheet;
  $('confirm').onclick = () => confirmBooking(h, when, p.now);
  openSheet('sheet');
}

function confirmBooking(h, when, total) {
  const code = 'HU-' + Math.random().toString(36).slice(2, 6).toUpperCase();
  $('sheetView').innerHTML = `
    <div class="grab"></div>
    <div class="sheet-h">
      <div>
        <div class="t">${t('booked.t')}</div>
        <div class="s">${h.nm} · ${when}</div>
      </div>
      <button class="x" id="sheetX" aria-label="Close">×</button>
    </div>
    <div class="sheet-b">
      <div class="done">
        <div class="tick">✓</div>
        <h3>${t('booked.head')}</h3>
        <p>${t('booked.code')}</p>
        <div class="code flapline" id="codeFlap"></div>
        <p style="margin-top:14px">${formatPrice(total)} · ${t('booked.pay')}</p>
      </div>
      <button class="cta" id="confirm">${t('booked.done')}</button>
      <div class="fine">${t('booked.confirmation')}</div>
    </div>`;
  setFlaps($('codeFlap'), code, true);
  $('sheetX').onclick = closeSheet;
  $('confirm').onclick = closeSheet;
}
